import { useState } from "react";
import { useBeforeUnmount } from "web_myplann/Shared/Hooks/useBeforeUnmount";
import { useHistoryEntryState } from "web_myplann/Shared/Hooks/useHistoryEntryState";

export const useInspirationJourney = <
	TInputs extends object,
	TSheet extends string,
>(
	initialInputs: TInputs,
) => {
	const { saved, save } = useHistoryEntryState<TInputs>("inspirationInputs");
	const [inputs, setInputs] = useState<TInputs>(saved ?? initialInputs);
	const [activeSheet, setActiveSheet] = useState<TSheet | null>(null);

	useBeforeUnmount(() => save(inputs));

	const patchInputs = (patch: Partial<TInputs>) =>
		setInputs((prev) => ({ ...prev, ...patch }));

	const closeSheet = () => setActiveSheet(null);

	const submitInputs = (patch: Partial<TInputs>) => {
		patchInputs(patch);
		closeSheet();
	};

	return {
		inputs,
		activeSheet,
		openSheet: (sheet: TSheet) => setActiveSheet(sheet),
		closeSheet,
		patchInputs,
		submitInputs,
	};
};
